import { render } from "react-dom";
import * as React from "react";
import NoData from "./../../components/Nodata";
import { useLocation, useParams } from "react-router-dom";
import {
  AccumulationChartComponent,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  Inject,
  AccumulationLegend,
  PieSeries,
  AccumulationTooltip,
  AccumulationDataLabel,
} from "@syncfusion/ej2-react-charts";
import { Grid, Box, Typography, Stack } from "@mui/material";
import { capitalize } from "lodash";
import { useTranslation } from "react-i18next";
export let data1 = [];
export default function PieChart({ lifeTimeCount, id, gender }) {
  const { t } = useTranslation("common");
  const location = useLocation();
  const color = [
    "#18B3F7",
    "#FF498D",
    "#FC6400",
    "#2678e8",
    "#0FEC63",
    "#8f00ff",
    "#FFEE20",
  ];
  const [data, setData] = React.useState([]);
  const params = useParams();
  // console.log(lifeTimeCount, "::::genderlifeTimeCount:::");
  // console.log(gender, "::gender***::");

  // React.useEffect(() => {
  //   if (lifeTimeCount) {
  //     setData([]);
  //     const d = [];

  //     for (const key in lifeTimeCount) {
  //       const i = Object.keys(lifeTimeCount).indexOf(key);
  //       d.push({
  //         x: key,
  //         y: lifeTimeCount[key].toFixed(2),
  //         text: key,
  //         color: color[i],
  //       });
  //     }
  //     setData([...d]);
  //   }
  // }, [lifeTimeCount]);

  React.useEffect(() => {
    if (gender) {
      setData([]);
      const d = [];

      for (const key in gender) {
        const i = Object.keys(gender).indexOf(key);
        d.push({
          x: key,
          y: gender[i].percentage.toFixed(2),
          // y: gender[key],
          text: key,
          color: color[i],
          gender: gender[i]["gender"],
          percentage: gender[i]["gender"],
          ageCategory: gender[i]["ageCategory"],
        });
      }
      setData([...d]);
    }
  }, [gender]);
  // React.useEffect(() => {
  //   if (gender) {
  //     const d = [];
  //     gender.forEach((g, index) => {
  //       d.push({ x: g[0], y: g[1] });
  //     });

  //     setData([...d]);
  //   }
  // }, [gender]);

  // React.useEffect(() => {
  //   if (params) {
  //     setData([]);
  //   }
  // }, [params]);
  const toLower = (str) => {
    if (str) {
      str = str.toLowerCase();
      return str;
    }
    return str;
  };
  return (
    <div
      className="control-pane"
      style={{
        margin: "6px",
        // background: "#262626",
        background: "#090909",
        borderRadius: "5px",
        padding: "20px",
        position: "relative",
        minHeight: "300px",
      }}
    >
      <Typography sx={{ color: "#FFFFFF80", fontSize: "17px" }}>
        {capitalize(id)}
      </Typography>
      {data.length > 0 ? (
        <Grid container spacing={2}>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box>
              {data &&
                data.map((d, index) => (
                  <Stack
                    direction="row"
                    gap="10px"
                    alignItems="center"
                    marginTop="4px"
                    key={index}
                  >
                    <Box
                      sx={{
                        width: "10px",
                        height: "10px",
                        background: d.color,
                        borderRadius: "2px",
                      }}
                    ></Box>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography sx={{ textTransform: "capitalize" }}>
                        {toLower(d?.gender) || toLower(d?.ageCategory)}
                      </Typography>
                      <Typography>: {d.y}%</Typography>
                    </Stack>
                  </Stack>
                ))}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box>
              <AccumulationChartComponent
                height="200"
                id={id}
                ref={(pie) => (pie = pie)}
                legendSettings={{ visible: false }}
                load={(args) => load(args)}
                enableSmartLabels={true}
                enableAnimation={false}
                tooltip={{
                  enable: true,
                  format: "${point.x} : <b>${point.y}%</b>",
                  textStyle: {
                    fontWeight: "600",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                  },
                }}
                loaded={() => onChartLoad()}
              >
                <Inject
                  services={[
                    AccumulationLegend,
                    PieSeries,
                    AccumulationTooltip,
                    AccumulationDataLabel,
                  ]}
                />
                <AccumulationSeriesCollectionDirective>
                  <AccumulationSeriesDirective
                    dataSource={data}
                    pointColorMapping="color"
                    name={id}
                    xName="x"
                    yName="y"
                    explode={true}
                    explodeOffset="0%"
                    explodeIndex={0}
                    dataLabel={{
                      // visible: true,
                      position: "Inside",
                      name: "text",
                      font: {
                        fontWeight: "600",
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      },
                    }}
                    radius="100%"
                  ></AccumulationSeriesDirective>
                </AccumulationSeriesCollectionDirective>
              </AccumulationChartComponent>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <NoData lable={t("noDataToShow")} />
      )}
    </div>
  );

  function onChartLoad(args) {
    document.getElementById(id).setAttribute("title", "");
  }
  function load(args) {
    let selectedTheme = location.hash.split("/")[1];
    selectedTheme = selectedTheme ? selectedTheme : "Material";
    args.accumulation.theme = "DARK";
  }
}
